export default "__VITE_ASSET__BhdIBGBJ__"